<template>
  <b-form @keydown="form.errors.clear()" @submit.prevent="onSubmit">
    <b-card>
      <template #header>Enable</template>
      <div :class="{ 'has-danger': form.errors.has('is_quote') }" class="form-group row mb-0">
        <div class="col-3 col-form-label text-right">Enable User Level Branding</div>
        <div class="col-8">
          <core-switch v-model="form.override" color="primary" variant="3d" />
        </div>
      </div>
      <div class="row">
        <div class="col-3"></div>
        <div class="col-8">
          <small class="form-text text-muted">
            Enable this to allow the user to override the default branding settings.<br />
            <br />
            <b>If left empty</b>, the setting will inherit from the default branding settings.<br />
            For Address fields, if one field is set, the entire address will be used.<br />
          </small>
        </div>
      </div>
    </b-card>

    <template v-if="form.override">
      <b-card>
        <template #header>General</template>
        <form-text v-model="form.business_entity_name" name="business_entity_name" />
        <form-text v-model="form.abn" name="abn">ABN</form-text>
      </b-card>

      <b-card>
        <template #header>Contact</template>
        <form-text id="branding-phone" v-model="form.phone" name="phone" />
        <form-email v-model="form.billing_email" name="billing_email" />
        <form-email v-model="form.email_from" name="email_from">'From' Email Address</form-email>
      </b-card>

      <b-card>
        <template #header>Office Location</template>
        <form-text v-model="form.street" name="street" />
        <form-text v-model="form.city" name="city" />
        <form-text v-model="form.state" name="state" />
        <form-text v-model="form.postcode" name="postcode" />
      </b-card>

      <b-card>
        <template #header>Account</template>
        <form-textarea v-model="form.bank_account" name="bank_account" />
      </b-card>

      <b-card class="d-none">
        <template #header>Payment Gateway</template>

        <form-bootstrap-radio
          v-if="!$store.getters['payment-gateway/isSingleGateway']()"
          v-model="form.payment_gateway"
          :options="['Stripe', 'PayChoice']"
          name="gateway"
        />
        <form-text
          v-if="form.payment_gateway === 'Stripe'"
          v-model="form.stripe_secret"
          name="stripe_secret"
        />
        <template v-if="form.payment_gateway === 'PayChoice'">
          <form-text v-model="form.paychoice_username" name="paychoice_username" />
          <form-text v-model="form.paychoice_password" name="paychoice_password" />
        </template>
      </b-card>
    </template>

    <div class="text-right">
      <button :disabled="form.notReady()" class="btn btn-primary">
        <font-awesome-icon v-if="form.busy" :icon="['fal', 'spinner']" spin />
        <font-awesome-icon v-else :icon="['fal', 'check']" />
        Save
      </button>
    </div>
  </b-form>
</template>

<script type="text/babel">
export default {
  props: {
    currentUser: {
      required: true,
    },
  },

  data() {
    return {
      form: new window.AppForm({
        override: false,
        user_id: null,
        business_entity_name: null,
        abn: null,
        street: null,
        city: null,
        state: null,
        postcode: null,
        billing_email: null,
        phone: null,
        email_from: null,
        bank_account: null,

        payment_gateway: this.$store.getters["payment-gateway/defaultGateway"](),
        stripe_secret: "",
        paychoice_username: "",
        paychoice_password: "",
      }),
    };
  },
  created() {
    this.init();
  },

  methods: {
    init() {
      this.$http.get(`/users/${this.currentUser.id}/branding`).then((response) => {
        this.form.loadData(response.body);

        this.form.finishProcessing();
      });
    },

    onSubmit() {
      this.form.put(`/users/${this.currentUser.id}/branding`).then(() => {
        this.init();
        window.toastr.success("User Branding updated!", "Success");
      });
    },
  },
};
</script>
